import { __decorate, __metadata } from "tslib";
import { IsIn } from 'class-validator';
export class EventOutcome {
    constructor(status, reason) {
        this.status = status;
        this.reason = reason;
    }
    isFailure() {
        return this.status === 'FAILURE';
    }
}
__decorate([
    IsIn(['SUCCESS', 'FAILURE']),
    __metadata("design:type", String)
], EventOutcome.prototype, "status", void 0);
